import { 
    CLEAR_STATE, 
    SET_ERROR, 
    SET_PAYMENT_DETAILS, 
    SET_SPEND_ALLOWANCE, 
    SET_WALLET_DETAILS, 
    SET_WALLET_STATUS 
} from "./cryptoWalletTypes"


const initialState = {
    error: null,
    wallet: null,
    status: null,
    paymentDetails: null,
    chainId: 0,
}


export default (state = initialState, { type, payload }) => {
    switch(type) {
        case SET_WALLET_STATUS: {
            return {
                ...state,
                status: payload
            }
        }

        case SET_WALLET_DETAILS: {
            return {
                ...state,
                wallet: payload.wallet,
                connecting: false,
                chainId: payload.chainId
            }
        }

        case SET_PAYMENT_DETAILS: {
            return {
                ...state,
                paymentDetails: payload
            }
        }

        case SET_SPEND_ALLOWANCE: {
            return {
                ...state,
                spendAllowance: payload
            }
        }

        case SET_ERROR: {
            return {
                ...state,
                error: payload
            }
        }

        case CLEAR_STATE: {
            if(payload && payload.leavePayDetails) {
                return {
                    ...initialState,
                    paymentDetails: state.paymentDetails
                }
            }
            return {
                ...initialState
            }
        }

        default: {
            return state;
        }

    }
}